import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import { connect } from "formik";
import { compose } from "redux";
import _ from "lodash";
import { AutoCompleteInput, PercentInput, DecimalInput } from "components/Global/FormikMaterial";
import { FIXED_RATE, FLOATING_RATE } from "components/Calculators/Constants/InterestRateType";
import {
  SPREAD_MAINTENANCE,
  MAKE_WHOLE,
  YIELD_MAINTENANCE_TRADITIONAL,
  YIELD_MAINTENANCE_AGENCY_STYLE,
  DEFEASANCE
} from "components/Calculators/Constants/PrepaymentType";

import {
  curves,
  interestRateTypes
} from "../Constants/DropDownLists";

import FormSectionTitle from "./FormSectionTitle";

const amortizationCurves = [...curves];
const index = amortizationCurves.findIndex(x => x.Name === "Cap Vols"); // cannot amortize based on cap vols
amortizationCurves.splice(index, 1);

function isFloatingSelected(interestRateType) {
  return !interestRateType || interestRateType === FLOATING_RATE;
}

function isFixedSelected(interestRateType) {
  return !interestRateType || interestRateType === FIXED_RATE;
}

const StyledAutoCompleteInput = styled(AutoCompleteInput)`
  && {
    width:100%;
    color: rgb(0, 0, 0);
  }
`;
const StyledDecimalInput = styled(DecimalInput)`
  & {
    width:100%;
  }
`;
const StyledPercentInput = styled(PercentInput)`
  & {
    width:100%;
  }
`;
const StyledLabel = styled.div`{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
 }`;

const InterestRatesFormSection = ({ formik }) => {
  const { values } = formik;

  const actualInterestRateTypes = [...interestRateTypes];
  const floatingOnlyPrepaymentTypes = [MAKE_WHOLE, YIELD_MAINTENANCE_TRADITIONAL, YIELD_MAINTENANCE_AGENCY_STYLE, DEFEASANCE];
  const replacementRateSpreadTypes = [MAKE_WHOLE, YIELD_MAINTENANCE_TRADITIONAL, YIELD_MAINTENANCE_AGENCY_STYLE];
  let isDisabled = false;
  if (values.prepaymentType === SPREAD_MAINTENANCE) {
    _.remove(actualInterestRateTypes, e => e.value === FIXED_RATE);
    values.interestRateType = FLOATING_RATE;
    isDisabled = true;
  } else if (_.findIndex(floatingOnlyPrepaymentTypes, e => e === values.prepaymentType) > -1) {
    _.remove(actualInterestRateTypes, e => e.value === FLOATING_RATE);
    values.interestRateType = FIXED_RATE;
    isDisabled = true;
  }
  const isReplacementRateSpreadType = _.findIndex(replacementRateSpreadTypes, e => e === values.prepaymentType) > -1;
  const shouldHideFixedRate = isFloatingSelected(values.interestRateType);
  const shouldHideFloatingRate = isFixedSelected(values.interestRateType);

  return (
    <>
      <Grid item xs={12}>
        <FormSectionTitle title="Interest Rate" />
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
        <StyledAutoCompleteInput
          label={<StyledLabel>{"Interest Rate Type"}</StyledLabel>}
          fieldName="interestRateType"
          selectValue="value"
          options={actualInterestRateTypes}
          isDisabled={isDisabled}
        />

      </Grid>
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3} hidden={shouldHideFixedRate}>
        <StyledPercentInput
          label={<StyledLabel>{"Rate (%)"}</StyledLabel>}
          decimalScale={3}
          fieldName="interestRate"
          allowNegative={false}
        />
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4} hidden={!isReplacementRateSpreadType}>
        <StyledPercentInput
          label={<StyledLabel>{"Replacement Rate Spread"}</StyledLabel>}
          decimalScale={3}
          fieldName="replacementRateSpread"
          allowNegative
        />
      </Grid>

      <Grid item xs={3} sm={3} md={3} lg={3} xl={3} hidden={shouldHideFloatingRate}>
        <StyledAutoCompleteInput
          label={<StyledLabel>{"Benchmark/Index"}</StyledLabel>}
          fieldName="curve"
          selectValue="value"
          options={amortizationCurves}
        />
      </Grid>
      <Grid item xs={2} sm={2} md={2} lg={2} xl={2} hidden={shouldHideFloatingRate}>
        <StyledDecimalInput
          label={<StyledLabel>{"Spread (bps)"}</StyledLabel>}
          fieldName="spread"
        />
      </Grid>
    </>
  );
};
export default compose(
  connect
)(InterestRatesFormSection);
